import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
  isOfferingListing,
} from '@b-stock/fe-core/bstock-next/queries'

import { OfferingInfo } from './OfferingInfo'

export const OfferingInfoSection = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  if (!isOfferingListing(listing) || listing.offering?.offerScope !== 'ITEM') {
    return null
  }

  return (
    <OfferingInfo
      itemsTotal={listing.itemsTotal}
      offerEndTime={listing.offering.offerEndTime}
      status={listing.status}
    />
  )
}
